import { selectIcon } from "../components/UI/selector";
import { CheckValue } from "./CommonFunction";
import moment from "moment";
import { getWhiteLabelData } from "./Constants";
import _ from "lodash";

const setDate = (date) => {
  if (date) {
    return moment(date).add(new Date(date).getTimezoneOffset(), "minutes");
  }
  return null;
};

export const setLocation = (el) => ({
  name: el.location_name || "",
  value: el.location_id,
});

export const setCoach = (el) => ({
  name: el.first_name + " " + el.last_name,
  first_name: el.first_name,
  last_name: el.last_name,
  id: el.user_id,
  keyValue: "id",
  thumb: el.profile_pic_thumb || selectIcon("userDummy"),
  original: el.profile_pic_original || selectIcon("userDummy"),
});

export const setAccessTokenRespone = (payload) => {
  /* TEMP solution */
  localStorage.setItem("name", payload.first_name + payload.last_name);
  localStorage.setItem("thumb", payload.profile_pic_thumb);
  localStorage.setItem(
    "supportLink",
    "https://www.tribe.fitness/mobile-support?firstname=" +
      payload.first_name +
      "&lastname=" +
      payload.last_name +
      "&email=" +
      payload.email
  );
  /* END */

  const { isWhiteLabeled } = getWhiteLabelData();
  const defaultGym = payload.gyms.length
    ? payload.gyms.find((gym) => {
        return gym.is_this_user_default_gym || isWhiteLabeled;
      })
    : null;
  const tribeGym = payload.gyms.length
    ? payload.gyms.find((gym) => {
        return gym.is_default_gym || isWhiteLabeled;
      })
    : null;
  const data = {
    name: `${payload.first_name || ""}${
      payload.last_name ? " " + payload.last_name : ""
    }`,
    first_name: payload.first_name,
    gender: payload.gender || "",
    email: payload.email || null,
    last_name: payload.last_name,
    thumb: payload.profile_pic_thumb || selectIcon("userDummy"),
    original: payload.profile_pic_original || selectIcon("userDummy"),
    imageUpload: CheckValue(payload.profile_pic_thumb),
    // dob: new Date(payload.dob || ''),
    dob: payload.dob || "",
    age: payload.age || 0,
    description: payload.description || null,
    user_id: payload.user_id || null,
    total_activities_as_member: payload.total_activities_as_member || 0,
    total_calories_burnt: payload.total_calories_burnt || 0,
    participant_video_visibility: payload.participant_video_visibility || null,
    weight_unit: payload.weight_unit || null,
    weight_value: payload.weight_value || null,
    height_unit: payload.height_unit || null,
    height_value: payload.height_value || null,
    gyms: payload.gyms.length ? payload.gyms : [],
    defaultGym: defaultGym,
    pendingGyms: payload.gyms.length
      ? payload.gyms.filter(
          (el) => el.linked_status === 0 || el.linked_status === 2
        )
      : [],
    approvedGyms: payload.gyms.length
      ? payload.gyms.filter(
          (el) => el.linked_status === 1 || el.linked_status === 3
        )
      : [],
    gymIds: payload.gyms.length ? payload.gyms.map((el) => el.gym_id) : [],
    is_email_verified: payload.is_email_verified || false,
    is_permanently_deleted: payload.is_permanently_deleted || false,
    is_profile_public: payload.is_profile_public || false,
    has_skipped_membership_code: payload.has_skipped_membership_code || false,
    has_skipped_link_facebook: payload.has_skipped_link_facebook || false,
    is_updated: payload.is_updated || false,
    is_welcome_email_sent: payload.is_welcome_email_sent || false,
    deletion_requested_at: payload.deletion_requested_at || null,
    currentStatus:
      (tribeGym && tribeGym.waiver_acceptance_message === null) ||
      tribeGym.is_waiver_accepted
        ? CheckValue(payload.first_name) &&
          payload.first_name.length &&
          payload.dob &&
          payload.dob.length
          ? payload.is_email_verified
            ? payload.gyms.length > 1 || payload.has_skipped_membership_code
              ? "complete"
              : "joinStudio"
            : "verifyEmail"
          : "userDetails"
        : "waiver",
  };
  return data;
};

export const SetCarouselDataApiResponse = (el) => {
  const data = {
    name: el.name || "",
    first_name: el.first_name || "-",
    last_name: el.last_name || "-",
    description: el.description || "-",
    playback_url: el.playback_url
      ? el.playback_url
      : el.ondemand_videos && el.ondemand_videos.length
      ? el.ondemand_videos[0]
      : null,
    thumb: el.profile_pic_thumb || selectIcon("userDummy"),
    original: el.profile_pic_original || selectIcon("userDummy"),
    activity_logo_thumb: el.activity_logo_thumb || selectIcon("userDummy"),
    activity_logo_original:
      el.activity_logo_original || selectIcon("userDummy"),
    started_at: setDate(el.started_at),
    gym_id: el.gym_id || null,
    activity_id: el.activity_id || null,
    duration_in_minutes: Math.round(el.duration_in_minutes) || null,
    recording:
      el.mp4_recording ||
      "https://dev-ivs-storage.s3.amazonaws.com/ivs/v1/771368300963/QxgWAwkkBx12/2022/7/26/3/53/xxDrzrvcTL42/media/master.mp4",
    logo_thumb: el.logo_thumb || selectIcon("userDummy"),
    workout_builder: el.workout_builder || [],
    equipments_required: el.equipments_required || [],
    location_name: el.location_name || [],
    ondemand_videos:
      el.ondemand_videos && el.ondemand_videos.length ? el.ondemand_videos : [],
    leaderboard_type: el.leaderboard_type,
    heartrate_required: el.heartrate_required,
    ended_at: el.ended_at || null,
    isNew: el.is_new || false,
  };
  return data;
};

export const SetCoachDataApiResponse = (el) => {
  const data = {
    user_id: el.user_id || "-",
    first_name: el.first_name || "-",
    last_name: el.last_name || "-",
    profile_pic_thumb: el.profile_pic_thumb || selectIcon("userDummy"),
    profile_pic_original: el.profile_pic_original || selectIcon("userDummy"),
  };
  return data;
};

export const SetCoachProfileApiResponse = (el) => {
  const data = {
    user_id: el.user_id || "-",
    first_name: el.first_name || "-",
    last_name: el.last_name || "-",
    number_of_ondemand_videos_published:
      el.number_of_ondemand_videos_published || 0,
    number_of_upcoming_activities: el.number_of_upcoming_activities || 0,
    profile_pic_thumb: el.profile_pic_thumb || selectIcon("userDummy"),
    profile_pic_original: el.profile_pic_original || selectIcon("userDummy"),
    live_Upcoming_activities_list: el.live_Upcoming_activities_list.length
      ? el.live_Upcoming_activities_list.map((el1) =>
          SetLiveAndUpcomingApiResponse(el1)
        )
      : [],
    ondemand_activities_list: el.ondemand_activities_list.length
      ? el.ondemand_activities_list.map((el1) =>
          SetCarouselDataApiResponse(el1)
        )
      : [],
  };
  return data;
};
export const SetCategoryProfileApiResponse = (el) => {
  const data = {
    category_info: el.category_info,
    total_ondemand_count: el.total_ondemand_count,
    total_schedule_count: el.total_schedule_count,
    live_and_upcoming:
      el.live_and_upcoming && el.live_and_upcoming.length
        ? el.live_and_upcoming.map((el1) => SetLiveAndUpcomingApiResponse(el1))
        : [],
    ondemand_classes:
      el.ondemand_classes && el.ondemand_classes.length
        ? el.ondemand_classes.map((el1) => SetCarouselDataApiResponse(el1))
        : [],
  };
  return data;
};

export const SetDashboardActivitiesApiResponse = (el) => {
  const data = {
    live_and_upcoming:
      el.live_and_upcoming && el.live_and_upcoming.length
        ? el.live_and_upcoming.map((el1) => SetLiveAndUpcomingApiResponse(el1))
        : [],
    my_upcoming_classes:
      el.my_upcoming_classes && el.my_upcoming_classes.length
        ? el.my_upcoming_classes.map((el1) =>
            SetLiveAndUpcomingApiResponse(el1)
          )
        : [],
    recommendation:
      el.recommendation && el.recommendation.length
        ? el.recommendation.map((el1) => SetCarouselDataApiResponse(el1))
        : [],
    new_classes:
      el.new_classes && el.new_classes.length
        ? el.new_classes.map((el1) => SetCarouselDataApiResponse(el1))
        : [],
    categories:
      el.categories && el.categories.length
        ? el.categories.map((el1) => SetCategoriesApiResponse(el1))
        : [],
    trending_class:
      el.trending_class && el.trending_class.length
        ? el.trending_class.map((el1) => SetCarouselDataApiResponse(el1))
        : [],
    activity_history:
      el.activity_history && el.activity_history.length
        ? el.activity_history.map((el1) => SetCarouselDataApiResponse(el1))
        : [],
  };
  const featured_categories_activities = _.omit(el, [
    "live_and_upcoming",
    "my_upcoming_classes",
    "recommendation",
    "new_classes",
    "categories",
    "trending_class",
    "activity_history",
  ]);
  data.featured_categories_activities = {};
  for (const key in featured_categories_activities) {
    data.featured_categories_activities[key] =
      featured_categories_activities[key];
  }
  return data;
};

export const SetLiveAndUpcomingApiResponse = (el) => {
  const data = {
    name: el.name || "",
    first_name: el.first_name || "-",
    last_name: el.last_name || "-",
    thumb: el.profile_pic_thumb || selectIcon("userDummy"),
    original: el.profile_pic_original || selectIcon("userDummy"),
    activity_logo_thumb: el.activity_logo_thumb || selectIcon("userDummy"),
    activity_logo_original:
      el.activity_logo_original || selectIcon("userDummy"),
    started_at: el.started_at || null,
    gym_id: el.gym_id || null,
    activity_id: el.activity_id || null,
    parent_activity_id: el.parent_activity_id || null,
    duration_in_minutes: el.duration_in_minutes || null,
    start_datetime: el.start_datetime || null,
    user_status_in_activity: el.user_status_in_activity || null,
    activity_status: el.activity_status || null,
  };
  return data;
};

export const SetCategoriesApiResponse = (el) => {
  const data = {
    category_id: el.category_id,
    category_name: el.category_name,
    category_image_original: el.category_image_original,
    category_image_thumb: el.category_image_thumb,
    category_position: el.category_position,
    is_icon_selected: el.is_icon_selected,
    is_featured: el.is_featured,
    is_published: el.is_published,
    gym_id: el.gym_id,
  };
  return data;
};

export const SetActivitySummaryApiResponse = (
  data,
  clubbedUsers,
  user_summary
) => {
  const obj = {
    name: data.name || "",
    first_name: data.first_name || "-",
    last_name: data.last_name || "-",
    thumb: data.profile_pic_thumb || selectIcon("userDummy"),
    activity_status: data.activity_status || null,
    activity_types: data.activity_types || [],
    started_at: data.started_at || null,
    ended_at: data.ended_at || null,
    clubbedUsers: clubbedUsers,
    duration_in_minutes: user_summary.duration_in_minutes || null,
    user_activity_session_id: user_summary.user_activity_session_id || null,
  };
  return obj;
};

export const SetActivityInfoApiResponse = (el) => {
  const data = {
    name: el.name || "--",
    first_name: el.first_name || "-",
    last_name: el.last_name || "-",
    thumb: el.profile_pic_thumb || selectIcon("userDummy"),
    original: el.profile_pic_original || selectIcon("userDummy"),
    activity_logo_thumb: el.activity_logo_thumb || selectIcon("userDummy"),
    activity_logo_original:
      el.activity_logo_original || selectIcon("userDummy"),
    // eslint-disable-next-line
    start_datetime: el.started_at,
    gym_id: el.gym_id || null,
    gym_name: el.gym_name || "--",
    logo_thumb: el.logo_thumb || selectIcon("userDummy"),
    activity_id: el.activity_id || null,
    parent_activity_id: el.parent_activity_id || null,
    duration_in_minutes: el.duration_in_minutes || 0,
    // eslint-disable-next-line
    start_datetime: el.start_datetime || null,
    user_status_in_activity: el.user_status_in_activity || null,
    activity_status: el.activity_status || null,
    activity_types: el.activity_types || [],
    coach_notes: el.coach_notes || null,
    description: el.description || null,
    privacy_setting: el.privacy_setting || "",
    private_hint: el.private_hint || "--",
    difficulty_level: el.difficulty_level || "--",
    tags: el.tags || [],
    workout_builder: el.workout_builder || [],
    equipments_required: el.equipments_required || [],
    location_name: el.location_name || [],
    playback_url: el.playback_url || null,
    ondemand_videos:
      el.ondemand_videos && el.ondemand_videos.length ? el.ondemand_videos : [],
    leaderboard_type: el.leaderboard_type,
    heartrate_required: el.heartrate_required,
    ended_at: el.ended_at || null,
    started_at: el.started_at || null,
    number_of_ondemand_videos_published:
      el.number_of_ondemand_videos_published || "---",
  };
  return data;
};

export const setGym = (el) => {
  const data = {
    name: el.name || `${el.first_name || "-"} ${el.last_name || "-"}`,
    first_name: el.first_name || el.name || "-",
    last_name: el.last_name || "-",
    email: el.email || "---",
    linked_role: el.linked_role || "",
    roles: el.roles,
    coach_profile_step: el.coach_profile_step || null,
    addedByName: `${el.added_by_user_first_name || ""} ${
      el.added_by_user_last_name || ""
    }`,
    addedByFirstName: el.added_by_user_first_name || "",
    linked_status: el.linked_status || 0,
    age: el.age || 0,
    dob: el.dob || "---",
    is_published: el.linked_status === 1 || el.linked_status === 4,
    date: setDate(el.updated_at),
    requestedOn: setDate(el.updated_at),
    addedOn: setDate(el.approved_at),
    thumb: el.profile_pic_thumb || el.logo_thumb || selectIcon("userDummy"),
    original:
      el.profile_pic_original || el.logo_original || selectIcon("userDummy"),
    id: el.gym_id || null,
    value: el.gym_id || null,
    keyValue: "id",
    membership_code: el.membership_code || "",
  };
  return data;
};

export const setActivityLogos = (el) => ({
  name: el.Key || "",
  id: el.activity_logo_thumb || el.url || "",
  keyValue: "id",
  thumb: el.activity_logo_thumb || el.url || selectIcon("userDummy"),
  original:
    el.activity_logo_original ||
    el.activity_logo_thumb ||
    el.url ||
    selectIcon("userDummy"),
});

export const SetListMyActivitiesApiRespnse = (el) => {
  const data = {
    id: el.activity_id || "000",
    userActSessionId: el.user_activity_session_id || "000",
    image: el.activity_logo_thumb || selectIcon("userDummy"),
    name: el.name || "",
    coach: el.first_name || "-",
    tags: el.activity_types || ["-"],
    // eslint-disable-next-line
    duration: parseInt(el.duration_in_minutes) || "--",
    // eslint-disable-next-line
    calories: parseInt(el.calories_burnt) || "-",
    rank: el.rank || "-",
    date: el.started_at || "-",
  };
  return data;
};

export const SetListUpcomingActivitiesDates = (el) => {
  return el.start_datetime || "-";
};
